import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { BudgetCategories } from "@project/domain/models/budget/financial-entity-budget.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetAllBudgetCategoriesByBudgetIdUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}
    async execute(budgetId: number): Promise<BudgetCategories> {
        const budgetCategoriesResult =
            await this.budgetRepository.getCategoriesByBudgetId(budgetId);

        return budgetCategoriesResult.fold(
            () => new BudgetCategories([], 0),
            (budgetCategories) => budgetCategories,
        );
    }
}
